export interface ProjectFeatureSupport {
  supports_assay: boolean
  supports_channel: boolean
  supports_workbook: boolean
}

export type ProjectReviewFeature = 'assay' | 'channel' | 'workbooks'

export function projectFeatures(settings?: Partial<ProjectFeatureSupport>): ProjectFeatureSupport {
  return {
    supports_assay: settings?.supports_assay ?? true,
    supports_channel: settings?.supports_channel ?? true,
    supports_workbook: settings?.supports_workbook ?? true,
  }
}

export function supportedReviewFeatures(
  settings?: Partial<ProjectFeatureSupport>,
): ProjectReviewFeature[] {
  const support = projectFeatures(settings)
  const features: ProjectReviewFeature[] = []
  if (support.supports_assay) features.push('assay')
  if (support.supports_channel) features.push('channel')
  if (support.supports_workbook) features.push('workbooks')
  return features
}
